<template>
	<v-sheet outlined rounded class="pa-4" min-height="100%" v-if="result">
		<span class="success--text font-weight-bold">{{ countLabel }}</span>

		<div class="d-flex justify-space-between align-center mt-2 mb-6">
			<div>
				<div class="text-h6">"{{ filters.q }}"</div>
				<div class="primary--text mt-1">
					En:
					<router-link :to="{ name: 'ReadAgreement', params: { agreementId: result.id } }">
						<strong>{{ result.name }}</strong>
					</router-link>
				</div>
				<div class="primary--text">
					Proveedor:
					<strong>{{ result.owner.name }}<span v-if="result.owner.document"> — {{ result.owner.document }}</span></strong>
				</div>
			</div>
		</div>

		<div v-if="subResults.length === 0" class="text-center text--disabled caption pa-8">
			Sin fragmentos disponibles para mostrar.
		</div>

		<v-sheet
			outlined
			rounded
			class="pa-4 mb-4"
			v-for="(item, index) in subResults"
			:key="index"
		>
			<v-row justify="space-between" align="center" dense class="mb-2">
				<v-col>
					<span class="text--secondary caption">{{ item.docName }}</span>
					<span class="text--disabled caption ml-2">· Página {{ item.page }}</span>
				</v-col>
				<v-col cols="auto">
					<v-chip
						x-small
						dark
						label
						:color="item.type === 'CONTRATO' ? 'blue darken-1' : 'orange darken-1'"
					>
						{{ item.type }}
					</v-chip>
				</v-col>
			</v-row>

			<p class="body-2 mb-2" v-html="paintWord(item.content)" />

			<a href="#" @click.prevent="viewDocument(item)">Ver Documento</a>
		</v-sheet>
	</v-sheet>
</template>

<script>
import { mapActions } from 'vuex';
import { showSnack } from '@/helpers/globalHelpers';

export default {
	name: 'SupplyKeywordPreview',

	props: {
		result: { type: Object, required: true },
		filters: { type: Object, required: true },
		docId: { type: [Number, String], default: null },
	},

	computed: {
		subResults() {
			const arr = [];
			const docs = [
				...(this.result.documents?.contrato || []),
				...(this.result.documents?.adenda || []),
			];
			docs.forEach((doc) => {
				if (this.docId && doc.id !== this.docId) return;
				const pages = Array.isArray(doc.supplyDocumentPages) ? doc.supplyDocumentPages : [];
				pages.forEach((p) => {
					arr.push({
						page: p.page,
						content: p.content,
						type: doc.type,
						docName: doc.name,
						fileUrl: doc.file_url,
					});
				});
			});
			return arr;
		},

		countLabel() {
			const n = this.subResults.length;
			if (n === 1) return '1 resultado';
			if (n > 1) return `${n} resultados`;
			return '';
		},
	},

	methods: {
		...mapActions('contract', ['signedFileUrl']),

		paintWord(text) {
			if (!this.filters?.q || !text) return text;
			const keyword = this.filters.q.toLowerCase();
			const sentences = text.split(/(?<=\.)\s+/);
			let result = '';
			const regex = new RegExp(keyword, 'gi');
			for (const sentence of sentences) {
				if (sentence.toLowerCase().includes(keyword)) {
					result += sentence + ' <br><br>';
				}
			}
			return result
				? result.replace(regex, '<span class="back-yellow">$&</span>')
				: text.replace(regex, '<span class="back-yellow">$&</span>');
		},

		async viewDocument(item) {
			try {
				const { error, response } = await this.signedFileUrl({ fileUrl: item.fileUrl });
				if (error) {
					showSnack('No se pudo abrir el documento', 'error');
					return;
				}
				const url = this.$router.resolve({
					name: 'ReadFile',
					query: { url: response.signedUrl, page: item.page },
				}).href;
				window.open(url, '_blank');
			} catch {
				showSnack('No se pudo abrir el documento', 'error');
			}
		},
	},
};
</script>

<style lang="scss">
.back-yellow {
	background-color: yellow;
}
</style>
